/* Free-gift cart bar: add gift/upsell items, and auto-remove the gift below the threshold.
   Loaded globally (layout) so it also works with the dynamically-rendered cart drawer. */
(function () {
  if (window.__giftBarGuard) return;
  window.__giftBarGuard = true;

  var THRESHOLD = 15000; // cents ($150)
  var GIFT_HANDLE = 'free-gift';
  var busy = false;

  // Re-render the cart regions from a fresh page fetch. Used after raw cart mutations
  // (variant swap) that bypass the theme's own cart store, so the drawer stays in sync.
  function refreshCart() {
    return fetch(window.location.pathname, { headers: { 'Accept': 'text/html' } })
      .then(function (r) { return r.text(); })
      .then(function (html) {
        var doc = new DOMParser().parseFromString(html, 'text/html');
        // Match the Nth current element to the Nth fresh element sharing an id, so duplicate
        // xo-unique-ids on the /cart page (drawer + page both render the gift bar) don't cross-contaminate.
        var seen = {};
        document.querySelectorAll('[xo-unique-id]').forEach(function (cur) {
          var id = cur.getAttribute('xo-unique-id');
          if (!id || !/cart|gift|club/i.test(id)) return;
          var esc = id.replace(/"/g, '');
          var idx = seen[esc] == null ? 0 : seen[esc] + 1;
          seen[esc] = idx;
          var list = doc.querySelectorAll('[xo-unique-id="' + esc + '"]');
          var fresh = list[idx] || list[0];
          if (fresh) cur.innerHTML = fresh.innerHTML;
        });
      })
      .catch(function () {});
  }

  // Power-bank toggle: add / remove the STANDALONE Power Bank product as its own clear line item.
  //   [data-pb-add]    = variant id of the solo power bank to add.
  //   [data-pb-remove] = cart line key of the solo power bank to remove.
  // The toggle flips colour immediately (feels instant), then the cart re-renders from the server.
  document.addEventListener('click', function (e) {
    var addBtn = e.target.closest('[data-pb-add]');
    var remBtn = e.target.closest('[data-pb-remove]');
    if (!addBtn && !remBtn) return;
    e.preventDefault();
    var btn = addBtn || remBtn;
    if (btn.getAttribute('disabled') != null) return;
    btn.setAttribute('disabled', '');
    var alert = btn.closest('.xo-pb-alert');

    if (addBtn) {
      // Optimistic green so it responds the instant they tap.
      btn.classList.add('xo-pb-toggle--on');
      if (alert) alert.classList.add('xo-pb-alert--ok');
      fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify({ items: [{ id: Number(addBtn.getAttribute('data-pb-add')), quantity: 1 }] })
      })
        .then(function (r) { if (!r.ok) throw new Error('add failed'); return refreshCart(); })
        .catch(function () {
          // Revert the optimistic green if the add didn't actually succeed (e.g. out of stock 422).
          btn.classList.remove('xo-pb-toggle--on');
          if (alert) alert.classList.remove('xo-pb-alert--ok');
          btn.removeAttribute('disabled');
        });
    } else {
      // Optimistic red so it responds the instant they tap.
      btn.classList.remove('xo-pb-toggle--on');
      if (alert) alert.classList.remove('xo-pb-alert--ok');
      fetch('/cart/change.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify({ id: remBtn.getAttribute('data-pb-remove'), quantity: 0 })
      })
        .then(function (r) { if (!r.ok) throw new Error('remove failed'); return refreshCart(); })
        .catch(function () {
          // Revert the optimistic red if the remove didn't actually succeed (e.g. stale line key).
          btn.classList.add('xo-pb-toggle--on');
          if (alert) alert.classList.add('xo-pb-alert--ok');
          btn.removeAttribute('disabled');
        });
    }
  });

  // Whether the gift is free is decided ENTIRELY by Shopify's "Free Gift" discount. This script must
  // NEVER strip a lone gift, or it would make the gift look "not free." So the guard does exactly one
  // thing: keep at most a single gift line, trimming genuine duplicates. It does not remove a single
  // gift based on any price or threshold guess.
  function guard() {
    if (busy) return;
    fetch('/cart.js', { headers: { 'Accept': 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        var gifts = (cart.items || []).filter(function (it) { return it.handle === GIFT_HANDLE; });
        if (gifts.length <= 1) return;   // 0 or 1 gift -> nothing to do; never touch a single gift
        var updates = {};
        gifts.forEach(function (l, i) { if (i > 0) { updates[l.key] = 0; } });  // keep one, trim the rest
        busy = true;
        // Remove the unearned/extra gift, then re-render the cart regions IN PLACE. No window reload:
        // a full-page reload was colliding with the theme's own remove and hanging the spinner.
        fetch('/cart/update.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ updates: updates })
        })
          .then(function (r) {
            if (!r.ok) throw new Error('cart update failed');
            return refreshCart();
          })
          .then(function () { busy = false; })
          .catch(function () { busy = false; });
      })
      .catch(function () {});
  }

  // Re-check after a cart mutation. Debounced so it runs AFTER the theme's own remove/update settles
  // instead of racing it (a concurrent corrective write is what left removes "stuck loading").
  var guardTimer = null;
  function scheduleGuard() {
    if (guardTimer) clearTimeout(guardTimer);
    guardTimer = setTimeout(guard, 600);
  }
  var origFetch = window.fetch;
  window.fetch = function (u) {
    var pr = origFetch.apply(this, arguments);
    try {
      var url = typeof u === 'string' ? u : (u && u.url) || '';
      if (url.indexOf('/cart/') > -1 && url.indexOf('/cart.js') === -1) {
        pr.then(function () { scheduleGuard(); });
      }
    } catch (e) {}
    return pr;
  };

  // One-time start-up check. Safe to run plainly now: guard() only ever does a silent in-place
  // re-render (no page reload), so there is no reload loop to guard against.
  if (document.readyState !== 'loading') { setTimeout(guard, 600); }
  else { document.addEventListener('DOMContentLoaded', function () { setTimeout(guard, 600); }); }
})();
